import { render } from "./user-dep.vue?vue&type=template&id=76220846&scoped=true"
import script from "./user-dep.vue?vue&type=script&lang=js"
export * from "./user-dep.vue?vue&type=script&lang=js"

import "./user-dep.vue?vue&type=style&index=0&id=76220846&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76220846"]])

export default __exports__